import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "features",
  class: "container mx-auto py-24 sm:py-32"
}
const _hoisted_2 = { class: "lg:w-[80%] mx-auto relative" }
const _hoisted_3 = { class: "pb-4" }
const _hoisted_4 = ["src", "alt"]

import { Card, CardContent, CardHeader, CardTitle } from "@/components/landingPage/ui/card";
import { Badge } from "@/components/landingPage/ui/badge";

interface HowItWorksProps {
  badgeTitle: string;
  title: string;
  description: string;
  image: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HowItWorks',
  setup(__props) {

const HowItWorksList: HowItWorksProps[] = [
  {
    badgeTitle: "Étape 1",
    title: "Créez votre profil personnalisé",
    description:
      "Créez votre avatar et complétez votre profil initial. Choisissez votre genre, style, humeur, passions et couleurs préférées dans un processus d'onboarding inclusif.",
    image: "roboto.png",
  },
  {
    badgeTitle: "Étape 2",
    title: "Découvrez vos forces à travers le jeu",
    description:
      "Participez à des mini-jeux ludiques pour révéler vos compétences : jeu des scénarios, suites logiques, métiers, vitesse, roue des compétences et environnement de travail.",
    image: "runner.png",
  },
  {
    badgeTitle: "Étape 3",
    title: "Recevez des recommandations IA",
    description:
      "L'algorithme de matching intelligent analyse vos résultats pour recommander des métiers, formations et entreprises compatibles avec votre profil unique.",
    image: "pacheco.png",
  },
  {
    badgeTitle: "Étape 4",
    title: "Construisez votre avenir professionnel",
    description:
      "Postulez à des stages et apprentissages, suivez vos candidatures et progressez avec l'accompagnement de professionnels spécialisés dans la neurodiversité.",
    image: "gamestation.png",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center mb-8" }, [
      _createElementVNode("h2", { class: "text-lg text-[#ff9500] text-center mb-2 tracking-wider" }, " Comment ça marche "),
      _createElementVNode("h2", { class: "text-3xl md:text-4xl text-center font-bold" }, " Votre parcours en 4 étapes ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HowItWorksList, ({ badgeTitle, title, description, image }, index) => {
        return _createElementVNode("div", {
          key: title,
          class: _normalizeClass([
          'flex mb-8 items-center',
          { ' flex-row-reverse': index % 2 !== 0 },
        ])
        }, [
          _createVNode(_unref(Card), { class: "h-full bg-transparent border-0 shadow-none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(Badge), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(badgeTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(CardContent), { class: "text-muted-foreground w-[80%]" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(description), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("img", {
            src: image,
            alt: `Image describing ${title} `,
            className: "w-[150px]  md:w-[250px] lg:w-[300px] mx-auto -scale-x-100 "
          }, null, 8, _hoisted_4),
          _createElementVNode("div", {
            class: _normalizeClass([
            '-z-10 absolute right-0 w-44 h-72  lg:w-64 lg:h-80 rounded-full bg-[#ff9500]/15 dark:bg-[#ff9500]/10 blur-3xl',
            {
              'left-0': index % 2 !== 0,
            },
          ])
          }, null, 2)
        ], 2)
      }), 64))
    ])
  ]))
}
}

})